import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('plan_shared_business_rule', baseUrl, 'business_rules')
const actions = generator.generate()

function baseUrl(params) {
  return `/plan_shared_business_rules/${params.id}?effective_date=${params.date}`
}

export default actions
